import React from "react";
import { Lock, Person } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";

export interface VaultCardUI {
  id: string;
  title: string;
  usernameEmail: string;
  imageUrl?: string | null;
  highSecurity?: boolean;
  password: string;
}

type VaultCardProps = {
  card: VaultCardUI;
  onClick?: () => void;
  passwordDisplay?: string;
};

export const VaultCard: React.FC<VaultCardProps> = ({ card, onClick, passwordDisplay }) => {
  const hasImage = Boolean(card.imageUrl && card.imageUrl.trim().length > 0);

  const oneLineEllipsis = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as const;

  return (
    <Box
      onClick={onClick}
      sx={{
        width: "100%",
        height: 60,
        display: "flex",
        mb: 1,
        background: "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: "1px solid var(--fx-surface-border, #E2E8F0)",
        alignItems: "center",
        cursor: "pointer",
        px: 1,
        gap: 1,
        boxShadow: "none",
        transition: "background-color 0.2s ease-in-out",

        "&:hover": {
          background: "var(--fx-colors-info-50, #EFF6FF)",
          border: "1px solid #e3f7ffff",
        },
      }}
    >
      <Avatar alt={card.usernameEmail} src={hasImage ? card.imageUrl! : undefined} sx={{ width: 30, height: 30 }}>
        {!hasImage ? <Person sx={{ fontSize: 18 }} /> : null}
      </Avatar>

      
      <Box sx={{ flex: 1, minWidth: 0, textAlign: "start" }}>
        <Typography sx={{ fontSize: 10, fontWeight: 800, ...oneLineEllipsis }}>{card.title}</Typography>

        <Typography sx={{ fontSize: 10, fontWeight: 500, ...oneLineEllipsis }}>{card.usernameEmail}</Typography>

        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            color: colors.gray?.[600] ?? "text.secondary",
            ...oneLineEllipsis,
          }}
        >
          ••••••••••••••
        </Typography>
      </Box>

      <Box sx={{ width: 24, display: "flex", justifyContent: "center", flexShrink: 0 }}>
        {card.highSecurity ? <Lock sx={{ color: colors.orange.base, fontSize: 18 }} /> : null}
      </Box>
    </Box>
  );
};

export default VaultCard;
